import React from 'react';
import { Box, Container, Typography, Card, CardContent, Grid, useTheme, useMediaQuery } from '@mui/material';
import { motion } from 'framer-motion';
import SchoolIcon from '@mui/icons-material/School';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

const Education = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const education = [
    {
      icon: <SchoolIcon sx={{ fontSize: 40 }} />,
      title: 'Senior Management Program',
      institution: 'IIM, Kolkata',
      gradient: 'linear-gradient(90deg, #0968E5, #091970)',
    },
    {
      icon: <WorkspacePremiumIcon sx={{ fontSize: 40 }} />,
      title: 'NSE Certification in Financial Market (NCFM)',
      institution: 'License Holder - All 2 Exams Cleared (2008)',
      gradient: 'linear-gradient(90deg, #0968E5, #091970)',
    },
    {
      icon: <WorkspacePremiumIcon sx={{ fontSize: 40 }} />,
      title: 'Certified Professional in Downstream Oil and Gas',
      institution: 'IEMA - Operation and Management',
      gradient: 'linear-gradient(90deg, #0968E5, #091970)',
    },
    {
      icon: <SchoolIcon sx={{ fontSize: 40 }} />,
      title: 'MBA',
      institution: 'EILM University - Marketing (Major) & Finance (Minor) (2007-2009)',
      gradient: 'linear-gradient(90deg, #0968E5, #091970)',
    },
    {
      icon: <SchoolIcon sx={{ fontSize: 40 }} />,
      title: 'Bachelor of Commerce',
      institution: 'S. A. Jaipuria College, University of Kolkata (2007)',
      gradient: 'linear-gradient(90deg, #0968E5, #091970)',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const cardVariants = {
    hidden: { x: -30, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.6 },
    },
  };

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        background: 'linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%)',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant={isMobile ? 'h4' : 'h3'}
          sx={{
            textAlign: 'center',
            mb: { xs: 4, sm: 5, md: 6 },
            fontWeight: 700,
            background: 'linear-gradient(90deg, #0968E5, #091970)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem', lg: '3rem' },
          }}
        >
          Education & Certifications
        </Typography>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Grid container spacing={3}>
            {education.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <motion.div variants={cardVariants}>
                  <Card
                    sx={{
                      height: '100%',
                      borderRadius: 4,
                      overflow: 'hidden',
                      position: 'relative',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-8px)',
                        boxShadow: '0 15px 50px rgba(0,0,0,0.2)',
                      },
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '5px',
                        background: item.gradient,
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        p: { xs: 3, md: 4 },
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 60, sm: 65, md: 70 },
                          height: { xs: 60, sm: 65, md: 70 },
                          borderRadius: '50%',
                          background: item.gradient,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          mb: { xs: 1.5, md: 2 },
                          boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                          '& svg': {
                            fontSize: { xs: 32, sm: 36, md: 40 },
                          },
                        }}
                      >
                        {item.icon}
                      </Box>
                      <Typography
                        variant={isMobile ? 'h6' : 'h6'}
                        sx={{
                          fontWeight: 700,
                          mb: { xs: 1, md: 1.5 },
                          color: '#333',
                          fontSize: { xs: '0.875rem', sm: '0.95rem', md: '1rem', lg: '1.1rem' },
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        variant={isMobile ? 'body2' : 'body2'}
                        sx={{
                          color: '#666',
                          fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem', lg: '0.9rem' },
                          lineHeight: { xs: 1.5, md: 1.6 },
                        }}
                      >
                        {item.institution}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Education;

